import { environment } from '../environments/environment';
var AppComponent = /** @class */ (function () {
    function AppComponent() {
        this.title = 'app';
        this.version = environment.version;
    }
    return AppComponent;
}());
export { AppComponent };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/app.component.ts.pre-build-optimizer.js